import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Entry } from 'contentful';
import FileSaver, { saveAs } from 'file-saver';
import { NdcVoucherLogsPage } from 'src/app/model/page/group/forms/ndc-voucher-logs-page';
import { ApiService } from 'src/app/service/api.service';
import { entraAuthService } from 'src/app/service/auth.service';
import { ContentfulService } from 'src/app/service/contentful.service';
import { ModelValidator } from 'src/app/validator/model-validator';

@Component({
  selector: 'app-ndc-voucher-logs-page',
  templateUrl: './ndc-voucher-logs-page.component.html',
  styleUrls: ['./ndc-voucher-logs-page.component.scss']
})
export class NdcVoucherLogsPageComponent implements OnInit {
  ndcVoucherLogsPage: NdcVoucherLogsPage = {} as NdcVoucherLogsPage;
  voucherLogsForm: FormGroup = new FormGroup({
    formType: new FormControl('issueVoucher'),
    startDate: new FormControl('', [Validators.required]),
    endDate: new FormControl('', [Validators.required])
  });
  downloadError: string='';
  accessError: string='';
  submitted = false;
  invalidEndDate = false;
  constructor(private contentfulService: ContentfulService, private apiService: ApiService, private authService: entraAuthService) {}

  ngOnInit(): void {
    const query = { 'fields.title': 'Get NDC Voucher Logs' };
    this.ndcVoucherLogsPage.sections = [];
    this.contentfulService.getPageContentResponse(query).then((ndcVoucherLogsPageEntries) => {
      this.mapBanner(ndcVoucherLogsPageEntries.includes.Entry);
      this.mapSections(ndcVoucherLogsPageEntries.includes.Entry);
      this.mapHtmlTitle(ndcVoucherLogsPageEntries.items);
    });
  }

  private mapHtmlTitle(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      this.ndcVoucherLogsPage.htmlTitle = entry.fields.htmlTitle;
    });
  }

  isAdmin(): boolean {
    const isAdmin = this.authService.getSignedInUser()?.isAdminUser;
    if (!isAdmin) {
      this.accessError = 'You are not authorized to view this page. Please contact administrator.';
    } else {
      this.accessError = '';
    }
    return isAdmin;
  }

  private mapBanner(ndcVoucherLogsPageEntries: Entry<any>[]) {
    ndcVoucherLogsPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let imageDetails: any = entry.fields['image'];
    let videoDetails: any = entry.fields['video'];

    this.ndcVoucherLogsPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url,
      video: videoDetails?.fields?.file?.url
    };
  }

  private mapSections(ndcVoucherLogsPageEntries: Entry<any>[]) {
    ndcVoucherLogsPageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        this.mapEntryToSection(entry);
      });

    this.ndcVoucherLogsPage.sections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToSection(entry: Entry<any>) {
    let givenTitle: any = entry.fields['title'] as string;
    let pageTitle = givenTitle.split('#').pop();

    this.ndcVoucherLogsPage.sections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number
    });
  }

  getToday(): string {
    return new Date().toISOString().split('T')[0];
  }

  async downloadCsv() {
    this.submitted = true;
    this.clearValidationError();
    if (this.voucherLogsForm.value.startDate > this.voucherLogsForm.value.endDate) {
      this.invalidEndDate = true;
    } else {
      let endpoint = '/issue';
      let fileName = 'issueVoucher';

      if (this.voucherLogsForm.value.formType === 'issueVoucher') {
        endpoint = '/voucher/issue';
        fileName = 'issueVoucher';
      } else {
        endpoint = '/voucher/redeem';
        fileName = 'redeemVoucher';
      }

      if (this.voucherLogsForm.valid) {
        let _this=this;
        let queryParams = new HttpParams();
        queryParams = queryParams.append('from', this.voucherLogsForm.value.startDate);
        queryParams = queryParams.append('to', this.voucherLogsForm.value.endDate);
        const apiResponse = await this.apiService.sendGetRequest(endpoint, queryParams, 'blob');
        if (apiResponse.success && apiResponse.success.type === 'text/csv') {
          var blob = new Blob([apiResponse.success], { type: 'text/csv;charset=utf-8' });
          FileSaver.saveAs(blob, fileName);
        } else if (apiResponse.error) {
          // console.log('apiResponse error : ', apiResponse.error);
          _this.downloadError = apiResponse.error.status == 404 ? 'No records found' : apiResponse.error.message;
        
        } else {
          _this.downloadError = 'Some error occurred. Please try again.';
        }
      }
    }
  }

  clearValidationError() {
    this.invalidEndDate = false;
    this.downloadError ='';
  }

  ngAfterViewChecked(): void {
    localStorage.removeItem('redirect_url');
  }
}
